import React from "react"

class Content extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <section className="section is-main-section">
                {this.props.children}
            </section>
        )
    }
}

export default Content